export type ServicesMenuItem = {
  slug: string;
  image: string;
};

export const servicesMenuItems: ServicesMenuItem[] = [
  {
    slug: "placas-solares-para-casas",
    image: "/static/services/service-cards/autoconsumo-domestico.webp",
  },
  {
    slug: "autoconsumo-industrial",
    image: "/static/services/service-cards/autoconsumo-industrial.webp",
  },
  {
    slug: "bombeo-solar",
    image: "/static/services/service-cards/bombeo-solar.webp",
  },
  {
    slug: "instalaciones-fotovoltaicas-aisladas",
    image: "/static/services/sistemas-aislados/sistemas-aislados-hero.webp",
  },
  {
    slug: "mantenimiento-instalaciones-fotovoltaicas",
    image: "/static/services/mantenimiento/mantenimiento-hero.webp",
  },
  {
    slug: "casos-de-exito",
    image: "/static/misc/producto-estrella-fallback.webp",
  },
];
